<template>
  <StoreSellerForm
    :title="$t('store-sellers.create.title')"
    :action="createSeller"
    :success-msg="$t('store-sellers.create.success')"
    :error-msg="$t('store-sellers.create.error')"
    @next="onCreated"
  />
</template>

<script>
import { mapActions } from 'vuex';
import StoreSellerForm from '@/components/ui/store-seller/StoreSellerForm';
import { storeSellerListRoute } from '@/utils/store-seller-routes';

export default {
  name: 'StoreSellerCreate',
  components: { StoreSellerForm },
  methods: {
    ...mapActions(['createSeller']),
    onCreated() {
      this.$router.push(storeSellerListRoute(this.$route.params.id));
    },
  },
};
</script>
